/* Ported from opfor-website ascii-top-drip — falling binary rain for the OPFOR bar */
(function () {
  const CHARS = "01";
  const INTRO_DUR = 1400;
  const BREATH_PERIOD = 3800;
  const BREATH_MIN = 0.3;
  const FPS_INTERVAL = 1000 / 24;
  const CFG = { columnWidth: 11, rowHeight: 10, density: 0.72, speed: 11 };

  function rand(lo, hi) {
    return lo + Math.random() * (hi - lo);
  }

  function clamp(v, lo, hi) {
    return Math.max(lo, Math.min(hi, v));
  }

  function getChar() {
    return CHARS[(Math.random() * CHARS.length) | 0];
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function gaussPeak(x, c, w, h) {
    const d = (x - c) / w;
    return h * Math.exp(-d * d);
  }

  function skyline(x) {
    let h = 0.08;
    h += gaussPeak(x, 0.0, 0.07, 0.95);
    h += gaussPeak(x, 0.18, 0.08, 0.16);
    h += gaussPeak(x, 0.34, 0.08, 0.22);
    h += gaussPeak(x, 0.4, 0.035, 0.42);
    h += gaussPeak(x, 0.67, 0.08, 0.2);
    h += gaussPeak(x, 0.72, 0.045, 0.56);
    h += gaussPeak(x, 1.0, 0.08, 0.95);
    h += Math.sin(x * Math.PI * 8) * 0.04;
    return clamp(h, 0.08, 1.0);
  }

  document.querySelectorAll("[data-announcement-bar-rain]").forEach((canvas) => {
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let W = 0;
    let H = 0;
    let cols = [];
    let lastTime = 0;
    let startTime = 0;
    let rafId = 0;
    let isInView = true;

    function stripHeight() {
      return canvas.parentElement?.clientHeight ?? 80;
    }

    function resize() {
      W = canvas.parentElement?.clientWidth ?? window.innerWidth;
      H = stripHeight();
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      canvas.width = Math.floor(W * dpr);
      canvas.height = Math.floor(H * dpr);
      canvas.style.width = `${W}px`;
      canvas.style.height = `${H}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      const count = Math.ceil(W / CFG.columnWidth);
      cols = Array.from({ length: count }, (_, i) => {
        const xNorm = i / Math.max(1, count - 1);
        const colH = skyline(xNorm) * H;
        const rows = Math.ceil(colH / CFG.rowHeight) + 2;
        return {
          x: i * CFG.columnWidth + rand(-1, 1),
          targetH: colH,
          rows,
          introDelay: rand(0, 400) + xNorm * 280,
          offset: rand(0, CFG.rowHeight * rows),
          speed: rand(CFG.speed * 0.55, CFG.speed * 1.45),
          alpha: rand(0.55, 1),
          size: rand(8, 10),
          phase: rand(0, Math.PI * 2),
          breathPhase: Math.PI / 2 + rand(-0.5, 0.5),
          chars: Array.from({ length: rows + 10 }, getChar),
        };
      });
    }

    function draw(ts) {
      if (!isInView || document.hidden) {
        rafId = 0;
        return;
      }
      rafId = requestAnimationFrame(draw);
      if (!startTime) startTime = ts;
      if (ts - lastTime < FPS_INTERVAL) return;
      const delta = Math.min(40, ts - lastTime || FPS_INTERVAL) / 1000;
      lastTime = ts;

      ctx.clearRect(0, 0, W, H);

      for (const col of cols) {
        const introProgress = clamp((ts - startTime - col.introDelay) / INTRO_DUR, 0, 1);
        const ease = easeOutCubic(introProgress);
        const breathTime = Math.max(0, ts - startTime - col.introDelay - INTRO_DUR);
        const breath = 0.5 + 0.5 * Math.sin((breathTime / BREATH_PERIOD) * Math.PI * 2 + col.breathPhase);
        const breathScale = BREATH_MIN + (1.0 - BREATH_MIN) * breath;
        const visH = col.targetH * (introProgress < 1 ? ease : breathScale);

        col.offset += col.speed * delta;
        if (col.offset > CFG.rowHeight) {
          col.offset -= CFG.rowHeight;
          col.chars.push(getChar());
          col.chars.shift();
        }

        const pulse = 0.8 + Math.sin(ts * 0.0015 + col.phase) * 0.2;
        ctx.font = `700 ${col.size}px ui-monospace, SFMono-Regular, "SF Mono", Menlo, monospace`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        for (let r = 0; r < col.rows; r++) {
          if (Math.random() > CFG.density) continue;
          const introFall = -(1 - ease) * 20;
          const y = r * CFG.rowHeight + col.offset + introFall;
          if (y < -10 || y > visH) continue;
          const topFade = clamp(y / 24, 0.18, 1);
          const bottomFadeVal = clamp((visH - y) / 40, 0.18, 1);
          const a = col.alpha * topFade * bottomFadeVal * pulse * ease;
          ctx.fillStyle = `rgba(255,77,79,${Math.min(a * 1.25, 1).toFixed(3)})`;
          ctx.shadowColor = "rgba(255,77,79,0.85)";
          ctx.shadowBlur = a > 0.55 ? 8 : 3;
          ctx.fillText(col.chars[r], col.x, y);
        }
      }

      ctx.shadowBlur = 0;
    }

    resize();
    window.addEventListener(
      "resize",
      () => {
        resize();
        startTime = performance.now() - INTRO_DUR;
      },
      { passive: true }
    );
    rafId = requestAnimationFrame(draw);

    const io = new IntersectionObserver(
      ([entry]) => {
        isInView = entry.isIntersecting;
        if (isInView && !document.hidden && !rafId) {
          lastTime = 0;
          rafId = requestAnimationFrame(draw);
        }
      },
      { threshold: 0 }
    );
    io.observe(canvas);
  });
})();
